import { IdentityErrorCode, identityErrors, PortalApiError } from './config'
import { isPortalApiError } from '@afterpaytouch/portal-api'
import { ErrorCode } from '@afterpaytouch/portal-api/types'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { SerializedError } from '@reduxjs/toolkit'

// @TODO: Remove and use generic error type in /types
interface IdentityVerifyErrorType {
  status: number
  data: PortalApiError
}

// @TODO: Remove and use generic error util in /utils
const isIdentityError = (error?: FetchBaseQueryError | SerializedError): error is IdentityVerifyErrorType => {
  return typeof error !== 'undefined' && 'data' in error
}

export const getIdentityVerifyErrorCode = (error?: FetchBaseQueryError | SerializedError): IdentityErrorCode | null => {
  if (isIdentityError(error)) {
    const { data } = error
    const errorCode = isPortalApiError(data) ? data.errorCode : ErrorCode.Error
    return identityErrors[errorCode] ?? IdentityErrorCode.Default
  }
  return null
}
